import * as React from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';

import { useStateTablePage } from '../../../common/component/hooks/useStateTablePage';

import { EventVideoInfoType } from '../../feature/type/EventVideoInfoType';
import { tableColumnList } from '../../const/eventVideoPageConst';
import { table, tableBox } from '../../const/eventVideoPageSize';

import theme from '../../../theme';

type Props = {
	eventVideoInfoList: EventVideoInfoType[] | [];
};

/**
 * イベント映像一覧テーブル
 */
export const EventVideoTable = (props: Props) => {
	const { eventVideoInfoList } = props;

	const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, handleTableRowClick, isRowSelected } = useStateTablePage(eventVideoInfoList); // テーブルページの状態管理用カスタムフック

	return (
		<Paper sx={{ height: tableBox.height, width: tableBox.width, overflow: 'hidden' }}>
			<TableContainer sx={{ maxHeight: table.height, minHeight: table.height }}>
				<Table stickyHeader size="small" aria-label="eventVideoTable">
					<TableHead>
						<TableRow>
							{tableColumnList.map((tableColumn, index) => (
								<TableCell
									key={index}
									style={{
										minWidth: tableColumn.minWidth,
										fontSize: 15,
										color: theme.palette.common.black,
										backgroundColor: '#d3d3d3',
										fontWeight: 'bold',
									}}
								>
									{tableColumn.label}
								</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody id="eventVideoTableBody">
						{eventVideoInfoList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
							return (
								<TableRow
									hover
									role="checkbox"
									tabIndex={-1}
									key={index}
									onClick={() => {
										handleTableRowClick(index);
									}}
									selected={isRowSelected(index)}
									aria-checked={isRowSelected(index)}
								>
									<TableCell key="occurrenceDatetime">
										{<Typography sx={{ fontSize: 12, color: theme.palette.common.black }}>{row.occurrenceDatetime}</Typography>}
									</TableCell>
									<TableCell key="organizationName">
										{<Typography sx={{ fontSize: 12, color: theme.palette.common.black }}>{row.organizationName}</Typography>}
									</TableCell>
									<TableCell key="carCode">
										{<Typography sx={{ fontSize: 12, color: theme.palette.common.black }}>{row.carCode}</Typography>}
									</TableCell>
									<TableCell key="numberPlate">
										{<Typography sx={{ fontSize: 12, color: theme.palette.common.black }}>{row.numberPlate}</Typography>}
									</TableCell>
									<TableCell key="driverName">
										{<Typography sx={{ fontSize: 12, color: theme.palette.common.black }}>{row.driverName}</Typography>}
									</TableCell>
									<TableCell key="model">{<Typography sx={{ fontSize: 12, color: theme.palette.common.black }}>{row.model}</Typography>}</TableCell>
									<TableCell key="eventType">
										{<Typography sx={{ fontSize: 12, color: theme.palette.common.black }}>{row.eventType}</Typography>}
									</TableCell>
									<TableCell key="gValue">{<Typography sx={{ fontSize: 12, color: theme.palette.common.black }}>{row.gValue}</Typography>}</TableCell>
									<TableCell key="hiyariLevel">
										{<Typography sx={{ fontSize: 12, color: theme.palette.common.black }}>{row.hiyariLevel}</Typography>}
									</TableCell>
									<TableCell key="legalSpeed">
										{<Typography sx={{ fontSize: 12, color: theme.palette.common.black }}>{row.legalSpeed}</Typography>}
									</TableCell>
									<TableCell key="overspeed">
										{<Typography sx={{ fontSize: 12, color: theme.palette.common.black }}>{row.overspeed}</Typography>}
									</TableCell>
									<TableCell key="hiyariResult">
										{<Typography sx={{ fontSize: 12, color: theme.palette.common.black }}>{row.hiyariResult}</Typography>}
									</TableCell>
								</TableRow>
							);
						})}
					</TableBody>
				</Table>
			</TableContainer>
			<TablePagination
				rowsPerPageOptions={[20, 40]}
				component="div"
				count={eventVideoInfoList.length}
				rowsPerPage={rowsPerPage}
				page={eventVideoInfoList.length ? page : 0}
				onPageChange={handleChangePage}
				onRowsPerPageChange={handleChangeRowsPerPage}
			/>
		</Paper>
	);
};
